module.exports = __webpack_public_path__ + "img/ly.91a1c809.svg";